import config from "../_core/config";

export const getKDV = () => {
    return config.KDV;
};

export const getKDVPercentage = () => {
    return parseFloat((getKDV() * 100).toFixed(2));
};

export const calculateKDV = amount => {
    if (!amount) return 0;
    return parseFloat((amount * getKDV()).toFixed(2));
};

//KDV eklenmiş tutarı hesaplar
export const calculateKDVAddedAmount = amount => {
    if (!amount) return 0;
    return parseFloat((amount + calculateKDV(amount)).toFixed(2));
};
